// extracted by mini-css-extract-plugin
export default {"container":"Contents_container__NlOY0","article_list":"Contents_article_list__yeb1K"};